

import { AbstractAccessorService, IDataAccessor } from "@core/data-access";
import { IGlobalUniqueIdServiece } from "./global-unique-id.interface";
import { UniqueIdGenerator } from "@modules/common/tool/UniqueIdGenerator";

/**
 ** 1.最大缓存数量的处理 最大数量 可以与定制时的PC数量有关系
 ** 2.最小缓存数量的处理 当缓存数量少于最小缓存数量时,进行缓数量存补充处理,将缓存补充为最大缓存
 ** 3.缓存储处理 目前存储在当前服务中,可以存到浏览器缓存中,Local storage
 ** 4.多次快速ID获取请求,可能出现 竞态问题
 //*TODO - 获取服务器ID报错不需要特殊处理，使用本地ID即可
 */
export class GlobalUniqueIdService extends AbstractAccessorService<number> implements IGlobalUniqueIdServiece {

    public readonly $name: string = "globalUniqueIdService";

    public static readonly $inject: string[] = [
        "$accessor", '$q', "$timeout",
    ];

    private cacheIdList: Array<number> = [];

    constructor(
        public $accessor: IDataAccessor<number>,
        public $q: angular.IQService,
        public $timeout: angular.ITimeoutService,
        public cacheQty: {
            max: number,
            min: number
        }
    ) {
        cacheQty = {
            min: 10,
            max: 30
        }
        super();
    }

    /**
     * @description 获取一个ID从缓存中获取
     */
    getId(): Promise<number> {
        let defer = this.$q.defer<number>();
        let cacheId = this.getCacheUniqueId();
        let that = this;
        if (cacheId && angular.isNumber(cacheId)) {
            this.$timeout(() => {
                defer.resolve(cacheId);
            });
        } else {
            this.getAll({ size: this.cacheQty.max }).then((value) => {
                if ((value.Success || value.success) && value.data) {
                    that.saveCacheUniqueId(value.data);
                    let cacheId = this.getCacheUniqueId();
                    if (angular.isNumber(cacheId)) {
                        defer.resolve(cacheId);
                    } else {
                        defer.resolve(UniqueIdGenerator.generateNewId());
                    }
                } else {
                    defer.resolve(UniqueIdGenerator.generateNewId());
                }
            }).catch((error) => {
                console.error(error);
                defer.resolve(UniqueIdGenerator.generateNewId());
            });
        }
        return defer.promise as Promise<number>;
    }

    /**
     * @param qty 
     * @description 获取批量ID
     */
    getList(qty: number): Promise<Array<number>> {
        let defer = this.$q.defer<Array<number>>();
        let that = this;
        if (qty > 0) {
            //*看缓存够不够
            if (qty <= this.cacheIdList.length) {
                let cacheIds = this.getCacheUniqueId(qty) as Array<number>;
                //*缓存够，直接返回
                this.$timeout(() => {
                    cacheIds && defer.resolve(cacheIds);
                });
                //*取出缓存数据之后 如果小于最小数量将再次补充缓存为最大缓存数量
                if (this.cacheIdList.length <= this.cacheQty.min) {
                    let getQty = this.cacheQty.max - this.cacheIdList.length;
                    this.getAll({ size: getQty }).then((value) => {
                        if ((value.Success || value.success) && value.data) {
                            that.saveCacheUniqueId(value.data);
                        }
                    }, (error) => {
                        //*TODO - 补充ID数量 获取ID报错
                        console.error(error);
                        that.saveCacheUniqueId(UniqueIdGenerator.generateNewIdList(getQty));
                    });
                }
            } else {
                //*看缓存不够，看差多少
                let getQty = (qty - this.cacheIdList.length) + this.cacheQty.max;
                this.getAll({ size: getQty }).then((value) => {
                    if ((value.Success || value.success) && value.data) {
                        that.saveCacheUniqueId(value.data);
                        let cacheIds = this.getCacheUniqueId(qty);
                        if (angular.isArray(cacheIds) && cacheIds.length > 0) {
                            defer.resolve(cacheIds);
                        } else {
                            defer.resolve(UniqueIdGenerator.generateNewIdList(getQty));
                        }
                    } else {
                        defer.resolve(UniqueIdGenerator.generateNewIdList(getQty));
                    }
                }, (error) => {
                    console.error(error);
                    defer.resolve(UniqueIdGenerator.generateNewIdList(getQty));
                });
            }
        } else {
            defer.reject(qty);
        }
        return defer.promise as Promise<Array<number>>;
    }

    //* 存储新的ID到 缓存中
    private saveCacheUniqueId(ids: Array<number>): void {
        if (angular.isArray(ids) && ids.length > 0) {
            this.cacheIdList = this.cacheIdList.concat(ids);
        }
    }

    //*每次获取ID都将跟新缓存中的ID数据
    private getCacheUniqueId(qty?: number): Array<number> | number | null {
        if (!angular.isNumber(qty) && this.cacheIdList && this.cacheIdList.length > 0) {
            let cacheId = this.cacheIdList.pop();
            return cacheId ? cacheId : null;
        } else if (qty && qty > 0 && this.cacheIdList.length >= qty) {
            let ids: Array<number> = [];
            for (let j = 0; j < qty; j++) {
                let id = this.cacheIdList.pop();
                id && ids.push(id);
            }
            return ids;
        }
        return null;
    }
}